import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ComplianceAttentionIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 4.583a.75.75 0 0 1 .75.75v2.4a.75.75 0 0 1-1.5 0v-2.4a.75.75 0 0 1 .75-.75m0 4.334a.75.75 0 0 1 .75.75v.1a.75.75 0 1 1-1.5 0v-.1a.75.75 0 0 1 .75-.75M3.307 4.403v3.183c0 1.852.99 3.561 2.596 4.482l2.096 1.203 2.096-1.203a5.17 5.17 0 0 0 2.596-4.482V4.403L8 2.606zm-1.5 3.183V4.288c0-.552.34-1.047.856-1.245l4.86-1.86c.306-.118.646-.118.953 0l4.859 1.86c.516.198.856.693.856 1.245v3.298a6.67 6.67 0 0 1-3.35 5.783l-2.179 1.25c-.41.236-.916.236-1.326 0l-2.18-1.25a6.67 6.67 0 0 1-3.35-5.783"
      clipRule="evenodd"
    />
  </svg>
);
ComplianceAttentionIcon.id = 'ComplianceAttentionIcon';
ComplianceAttentionIcon.displayName = 'ComplianceAttentionIcon';
export default ComplianceAttentionIcon;
